import { useContext } from 'react';

import { TMSContext } from '../contexts/tms';

export default function useTMSContext() {
  const tmsName = useContext(TMSContext);
  return tmsName;
}
